import React, { FC } from 'react'
import { Filter } from '@creditas/filter'
import { useQueryParam, StringParam } from 'use-query-params'
import { useTriage } from 'hooks/useTriage'

function getStatus(data?: Triage[]): string[] | undefined {
  if (!data) return undefined

  const statuses = []
  const unique = new Set(data?.map(item => item.status))

  for (const item of unique.values()) {
    statuses.push(item)
  }

  return statuses
}

export const StatusFilter: FC = () => {
  const { data } = useTriage()
  const [selected, setSelected] = useQueryParam('status', StringParam)
  const statuses = getStatus(data)

  return (
    <>
      {statuses &&
        statuses.map(status => (
          <Filter
            key={status}
            component="button"
            css={{ height: 'auto', marginRight: '12px' }}
            selected={selected === status}
            onClick={() => {
              if (selected !== status) return setSelected(status)
              return setSelected(null)
            }}
          >
            {status}
          </Filter>
        ))}
    </>
  )
}
